import React from 'react';
import { useDispatch } from 'react-redux';
import Container from '../../../containers/subject/subjectClasses/createSubjectClassContainer';
import { actions } from '../../../redux/subject/subjectClasses';

export default function () {
  const dispatch = useDispatch();
  React.useEffect(() => {
    dispatch(actions.getInitData({}));
  }, []);
  return (
    <Container />
  );
}
